import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  FormControl,
  Button,
  Container,
  InputGroup,
} from "react-bootstrap";
import Enquiry from "./enquirypopup";
import { ProductDropdowns, BASE_URL } from "./utility";

class MenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      filteredItems: [],
    };
    this.items = ProductDropdowns;
  }

  handleSearch = (e) => {
    const searchTerm = e.target.value;
    const filteredItems = this.items.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    this.setState({ searchTerm, filteredItems });
  };

  handleItemClick = (link) => {
    window.open(link, "_blank");
  };

  render() {
    const { searchTerm, filteredItems } = this.state;

    return (
      <div>
        {/* Custom Styles */}
        <style>{`
  .navbar-custom {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(6px);
    border-radius: 12px;
    margin: 10px auto;
    padding: 0.5rem 1rem;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1050;
  }
  .navbar-custom:hover {
    background: rgba(0, 0, 0, 0.75);
  }
  .navbar-brand img {
    border-radius: 8px;
  }
  .nav-link, .dropdown-item {
    font-weight: 500;
    color: white !important;
  }
  .nav-link:hover, .dropdown-item:hover {
    color: #33daff !important;
  }
  .new-arrivals-btn {
    background: linear-gradient(90deg, #28a745, #2ecc71);
    border: none;
    font-weight: 600;
    color: white;
    border-radius: 25px;
    padding: 8px 20px;
    animation: pulse 1.5s infinite;
  }
  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(46, 204, 113, 0); }
    100% { box-shadow: 0 0 0 0 rgba(46, 204, 113, 0); }
  }
  .search-dropdown input {
    width: 220px;
    margin: 8px;
    border-radius: 8px;
  }
  .search-dropdown .dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
    z-index: 2000 !important;
  }

  .dropdown-menu {
    background-color: rgba(0, 0, 0, 0.85);
    color: white;
    border-radius: 8px;
    padding: 0.5rem 0;
  }
  .dropdown-item {
    color: white !important;
  }
  .dropdown-item:hover, .dropdown-item:focus {
    background-color: #33daff !important;
    color: black !important;
  }

  /* ----------------------------------------------------
     📱 MOBILE & TABLET FIXES (≤991px)
     ----------------------------------------------------*/
  @media (max-width: 991px) {

    /* Center align nav text */
    .navbar-custom .nav-link,
    .navbar-custom .dropdown-toggle,
    .navbar-custom .dropdown-item {
      text-align: center !important;
    }

    /* Add proper spacing between nav elements */
    .navbar-custom .nav-link,
    .navbar-custom .dropdown-toggle {
      padding: 14px 0 !important;
      margin: 6px 0 !important;
      width: 100% !important;
    }

    /* Fix search input width */
    .search-dropdown input {
      width: 100% !important;
    }

    /* Keep dropdown inside navbar */
    .navbar-custom .dropdown-menu {
      position: static !important;
      width: 100% !important;
    }

    #search-dropdown .dropdown-menu {
      width: 100% !important;
    }

    .new-arrivals-btn {
      width: 100%;
      margin: 10px 0 !important;
      text-align: center !important;
    }

    /* RIGHT-SIDE BUTTON COLUMN FIX */
    .navbar-custom .ml-auto {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center !important;
      margin-top: 10px;
    }

    .navbar-custom .ml-auto .btn,
    .navbar-custom .ml-auto button {
      width: 90% !important;
      margin: 8px 0 !important;
      padding: 12px !important;
      text-align: center !important;
    }

    /* Talk to Us / Enquiry button */
    .enquiry-button {
      width: 90% !important;
      margin: 10px 0 !important;
      text-align: center !important;
    }
  }
`}</style>

        <Navbar
          collapseOnSelect
          expand="lg"
          variant="dark"
          className="navbar-custom"
        >
          <Container fluid>
            {/* Brand */}
            <Navbar.Brand href="/">
              <img
                src={`${BASE_URL}download/general/logo`}
                alt="Logo"
                height={40}
                width={40}
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <Nav className="mr-auto align-items-center">
                {/* 🔍 Search Products */}
                <NavDropdown
                  title={
                    <span style={{ color: "white" }}>Search Products</span>
                  }
                  id="search-dropdown"
                  container="body"
                  className="search-dropdown"
                >
                  <InputGroup className="px-3">
                    <FormControl
                      type="text"
                      placeholder="Type to search..."
                      value={searchTerm}
                      onChange={this.handleSearch}
                    />
                  </InputGroup>
                  {filteredItems.length > 0 ? (
                    filteredItems.map((item) => (
                      <NavDropdown.Item
                        key={item.id}
                        onClick={() => this.handleItemClick(item.link)}
                      >
                        {item.name}
                      </NavDropdown.Item>
                    ))
                  ) : (
                    <NavDropdown.Item disabled>
                      No matching items
                    </NavDropdown.Item>
                  )}
                </NavDropdown>

                {/* 🆕 New Arrivals */}
                <Nav.Link href="/newproducts" className="new-arrivals-btn mx-2">
                  New Arrivals
                </Nav.Link>

                {/* 🏢 About */}
                <Nav.Link href="/about" className="mx-2">
                  About Us
                </Nav.Link>

                {/* 📦 Products Dropdown */}
                <NavDropdown
                  title={<span style={{ color: "white" }}>Products</span>}
                  id="products-dropdown"
                  container="body"
                  className="mx-2"
                >
                  <NavDropdown.Header>
                    <Button
                      variant="secondary"
                      href="/products"
                      size="sm"
                      block
                    >
                      View All Products
                    </Button>
                  </NavDropdown.Header>
                  <NavDropdown.Divider />

                  {[
                    ["wallpapers", "Wallpapers"],
                    ["acousticbaffleceilings", "Acoustic Baffle Ceilings"],
                    ["woodenfloorings", "Wooden Floorings"],
                    ["claddings", "Claddings"],
                    ["awnings", "Awnings"],
                    ["blinds", "Blinds"],
                    ["wall2wall", "Wall-2-Wall Carpets"],
                    ["ceilings", "Ceilings"],
                    ["wpcbaffleceilings", "WPC Baffle Ceilings"],
                    ["soffitpanels", "Soffit Panels"],
                    ["solar", "Solar Films"],
                    ["agrass", "Artificial Grass"],
                    ["doormats", "Door Mats"],
                    ["pvcpanels", "PVC Panels"],
                    ["foampanels", "Foam Panels"],
                    ["verticalgarden", "Vertical Gardens"],
                    ["modulercarpets", "Modular Carpet Tiles"],
                    ["nexacarpets", "Nexa Carpets"],
                    ["fundermax", "Fundermax"],
                    ["aluminiumlouverpanels", "Aluminium Louver Panels"],
                    ["indoorwpclouvers", "Indoor WPC Panels"],
                    ["outdoorwpclouvers", "Outdoor WPC Panels"],
                    ["hpl", "HPL"],
                    ["gymfloorings", "Gym Floorings"],
                  ].map(([link, label]) => (
                    <NavDropdown.Item key={link} href={`/${link}`}>
                      {label}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                {/* 📄 Brochures */}
                <Nav.Link href="/brochures" className="mx-2">
                  Brochures
                </Nav.Link>

                {/* 📨 Enquiry Popup */}
                <Enquiry />
              </Nav>

              {/* Right-aligned Actions */}
              <Nav className="ml-auto align-items-center">
                {localStorage.getItem("token") ? (
                  <>
                    <Button
                      variant="success"
                      className="mx-2"
                      onClick={() => (window.location.href = "/operations")}
                    >
                      Operations
                    </Button>
                    <Button
                      variant="primary"
                      className="mx-2"
                      onClick={() => (window.location.href = "/dashboard")}
                    >
                      Dashboard
                    </Button>
                    <Button
                      variant="light"
                      className="mx-2"
                      onClick={() => {
                        localStorage.removeItem("token");
                        window.location.href = "/";
                      }}
                    >
                      Logout
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="info"
                    className="mx-2"
                    style={{
                      color: "black",
                      borderColor: "#33daff",
                      backgroundColor: "#33daff",
                    }}
                    onClick={() => (window.location.href = "/auth")}
                  >
                    Login
                  </Button>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}

export default MenuBar;
